import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { ProductInventoryTable } from "./product-inventory-table";

export const ProductInventoryList = observer(() => {
  const {
    productInventoryManagement: {
      productInventoryStore: {
        pagination,
        getProductsInventory,
        queryParams: { code, dealingName, name, barcode, setProp },
      },
    },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    await getProductsInventory();
  }, [getProductsInventory, pagination]);
  return (
    <>
      <PageFilterContainer
        direction={"row"}
        alignItems={"center"}
        sx={{ marginTop: "10px" }}
      >
        <XSearchTextField
          label="Tên giao dịch"
          value={dealingName}
          onChange={(e) => setProp("dealingName", e.currentTarget.value)}
        ></XSearchTextField>
        <XSearchTextField
          label="Tên hàng"
          value={name}
          onChange={(e) => setProp("name", e.currentTarget.value)}
        ></XSearchTextField>
        <XSearchTextField
          label="Mã hàng"
          value={code}
          onChange={(e) => setProp("code", e.currentTarget.value)}
        ></XSearchTextField>
        <XSearchTextField
          label="Mã barcode"
          value={barcode}
          onChange={(e) => setProp("barcode", e.currentTarget.value)}
        ></XSearchTextField>
        <SearchButton asyncAction={onSearch}></SearchButton>
      </PageFilterContainer>
      <PageContentContainer sx={{ marginTop: "10px" }}>
        <ProductInventoryTable></ProductInventoryTable>
      </PageContentContainer>
    </>
  );
});
